<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" ref="form" :inline="true" label-width="110px">
        <div class="input-box">
          <div>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="身份证：">
              <el-input v-model="form.idCard" placeholder="请输入身份证"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                Filter_file({api:api,data:form,callback:_d => tableData = _d })">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('cj_xnpkldljydtjgtz')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._dd"></file_Upload></el-button>
      <el-button type="primary" 
            v-if="showBtn[5].isShow"
            v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/吸纳贫困劳动力就业动态监管台账.xlsx" download="吸纳贫困劳动力就业动态监管台账.xlsx">下载模板</a> -->
        下载模板
      </el-button>
    </div> 
    <div class="table">
      <el-table
        :data="tableData"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="吸纳贫困劳动力就业动态监管台账"
      :visible.sync="centerDialogVisible"
      @close="close"
      width="1400px"
      :modal="false"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" size="mini" :rules="rules" ref="editForm" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item prop="name" label="姓名：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="性别：">
                          <el-input style="width:193px;" v-model="editForm.sex"></el-input>
                        </el-form-item>
                        <el-form-item prop="idCard" label="身份证号码：">
                          <el-input style="width:193px;" v-model="editForm.idCard"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="联系电话：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="现居住地：">
                          <el-input style="width:193px;" v-model="editForm.residence"></el-input>
                        </el-form-item>
                        <el-form-item label="工作起止时间：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.startWorkTime"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="就业扶贫车间名称：">
                          <el-input style="width:193px;" v-model="editForm.workShopName"></el-input>
                        </el-form-item>
                        <el-form-item label="是否签订劳动合同或劳务协议：">
                          <el-input style="width:193px;" v-model="editForm.hasJobProtocol"></el-input>
                        </el-form-item>
                        <el-form-item label="是否每月购15元以上意外伤害保险：">
                          <el-input style="width:193px;" v-model="editForm.hasInsurance"></el-input>
                        </el-form-item>
                        <el-form-item label="月平均工资(元)：">
                          <el-input style="width:193px;" v-model="editForm.salary"></el-input>
                        </el-form-item>
                        <el-form-item label="备注：">
                          <el-input style="width:193px;" v-model="editForm.remark"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/bobaiPoorRecord',
      form:{socialCode:''},
      isCreate:false,
      type:'14',
      centerDialogVisible:false,
      tableData:[],
      selectRow:[],
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        ownerName: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
      },
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},				
        {key: 'village', value: '村'},
        {key:'name',value:'姓名'},
        {key:'sex',value:'性别'},
        {key:'idCard',value:'身份证号码'},
        {key:'residence',value:'现居住地'},
        {key:'startWorkTime',value:'工作起止时间'},
        {key:'phone',value:'联系电话'},
        {key:'workShopName',value:'就业扶贫车间名称'},
        {key:'hasJobProtocol',value:'是否签订劳动合同或劳务协议'},
        {key:'hasInsurance',value:'是否每月购15元以上意外伤害保险'},
        {key:'salary',value:'月平均工资(元)'},
        {key:'remark',value:'备注'}
      ],
      
    }
  },
  created() {
    this.isShowBtn("BobaiPoorRecord")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.startWorkTime = new Date(newForm.startWorkTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */

.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
.info-title{
  text-align:center;
  margin:48px 0;
  color:rgb(153,153,153);
}
.text .el-form-item__label{
  text-align:justify;
  text-align-last:justify;
}
</style>